module.exports = __webpack_public_path__ + "img/4長型會客區.d4f8dce9.jpg";